"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _location = require("../../lib/location");
var _mapLink = _interopRequireDefault(require("../MapLink/map-link"));
var _providerAvailability = _interopRequireDefault(require("./provider-availability"));
var _providerLocationLink = _interopRequireDefault(require("./provider-location-link"));
var _provider = require("../../lib/provider");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/prop-types */
const ProviderLocation = _ref => {
  let {
    location,
    headers,
    searchedLocation,
    track,
    apptInfo,
    availability,
    slotsStatus,
    handleRetry,
    onClickShowAvailability,
    availabilityTilesMessages,
    provider,
    bookOnlineUrl,
    shouldDisplayAvailability,
    availabilityLinkTarget,
    onTimeSlotsClick,
    onAvailabilityTilesLoaded,
    getLocationUrl,
    locationCallback,
    locationCTA: LocationCTA
  } = _ref;
  const phoneNumber = (0, _location.getLocationPhoneNumber)(location);
  const phoneLink = `tel:${phoneNumber}`;
  const distance = location.distance && `${location.distance.toFixed(2)} miles` || null;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.LocationRow, {
    "data-name": location.name,
    key: location.name
  }, /*#__PURE__*/_react.default.createElement(_styles.AddressTd, null, /*#__PURE__*/_react.default.createElement(_providerLocationLink.default, {
    location: location,
    getLocationUrl: getLocationUrl,
    locationCallback: locationCallback
  }, location.name), (0, _location.getLocationDisplayAddress)(location), /*#__PURE__*/_react.default.createElement(_styles.LocationContainer, null, ' (', /*#__PURE__*/_react.default.createElement(_mapLink.default, {
    location: location,
    searchedLocation: searchedLocation,
    track: track
  }), ')')), headers.phone && /*#__PURE__*/_react.default.createElement(_styles.PhoneNumberTd, null, phoneNumber && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.PhoneAnchor, {
    href: phoneLink
  }, phoneNumber))), /*#__PURE__*/_react.default.createElement(_styles.DistanceTd, null, distance), LocationCTA && /*#__PURE__*/_react.default.createElement(_styles.LocationCtaTd, null, /*#__PURE__*/_react.default.createElement(LocationCTA, {
    providerDisplayName: (0, _provider.getProviderDisplayName)(provider),
    providerId: provider.id,
    location: location
  }))), shouldDisplayAvailability && location.slots && /*#__PURE__*/_react.default.createElement(_styles.AvailabilityRow, {
    shouldHideBelowScreenMedium: !availability
  }, /*#__PURE__*/_react.default.createElement(_styles.AvailabilityTd, {
    colSpan: 3
  }, /*#__PURE__*/_react.default.createElement(_providerAvailability.default, {
    apptInfo: apptInfo,
    availability: availability,
    slotsStatus: slotsStatus,
    handleRetry: handleRetry,
    onClickShowAvailability: onClickShowAvailability,
    availabilityTilesMessages: availabilityTilesMessages,
    providerId: provider.id,
    bookOnlineUrl: bookOnlineUrl,
    availabilityLinkTarget: availabilityLinkTarget,
    onTimeSlotsClick: onTimeSlotsClick,
    onAvailabilityTilesLoaded: onAvailabilityTilesLoaded
  }))));
};
/* eslint-enable react/prop-types */
var _default = exports.default = ProviderLocation;
ProviderLocation.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderLocation"
};